import { z } from "zod";
import { Timestamp } from "firebase/firestore";

// this lives in its own model file cus i was running into a circular import issue
// btwn membership.ts and invoice.ts

/**
 * membershipData: may appear on an estimateItem's customData, or an invoice's lineItem.
 *
 * on an invoice, membershipData is not persisted to the DB. it's used to create
 * a membership, then dropped. on an estimateItem, membershipData persists.
 */
export interface ItemMembershipData {
  membershipTemplateID: string;
  isSameTask: boolean;
  notes: string | null;
  selectedStartDate: Timestamp | null;
  renewedFromMembershipID?: string;
}

/**
 * Used to update an invoice's lineItems (via Express endpoint) with possible membershipData.
 *
 * Is nearly the same as ItemMembershipData, but any non-null selectedStartDate
 * values are expected to be ISO strings instead of Timestamps.
 */
export type ItemMembershipDataAPI = Omit<
  ItemMembershipData,
  "selectedStartDate"
> & {
  selectedStartDate: string | null;
};
export const itemMembershipDataAPISchema = z.object({
  membershipTemplateID: z.string(),
  isSameTask: z.boolean(),
  notes: z.string().nullable(),
  selectedStartDate: z.string().nullable(),
  renewedFromMembershipID: z.string().optional(),
}) satisfies z.ZodType<ItemMembershipDataAPI>;
